import React from 'react'
import { Field } from 'react-final-form'
import './PbtCustomImage.scss'
import { Message } from 'semantic-ui-react'

interface PbtCustomImageProps {
  index: number
  imageAdapter: any
  showDestroy: boolean
  hasError: boolean
}

const PbtCustomImage = ({ index, imageAdapter, showDestroy, hasError }: PbtCustomImageProps) => {
  return (
    <div className="pbtCustomImageCtr">
      <h2>Custom Image {index}</h2>
      {hasError && (
        <Message negative>
          <p>Must set image</p>
        </Message>
      )}
      <div className="field">
        <label>Position (0-4, 0 is first)</label>
        <Field
          name={`pbt_custom_images_attributes[${index}].position`}
          component="input"
          type="number"
          defaultValue={index}
          disabled={true}
          required={true}
        />
      </div>

      <div className="field">
        <label>
          Image URL (required). Must be 3:2 aspect ratio, at least 1920x1280, and JPG/PNG
        </label>
        <Field
          isBrandLogo={false}
          name={`pbt_custom_images_attributes[${index}].image_url`}
          type="text"
          component={imageAdapter}
        />
      </div>

      <div className="field">
        <label>CTA Text (call to action)</label>
        <Field component="input" name={`pbt_custom_images_attributes[${index}].cta_text`} />
      </div>

      <div className="field">
        <label>CTA URL</label>
        <Field
          component="input"
          type="text"
          name={`pbt_custom_images_attributes[${index}].cta_url`}
        />
      </div>

      <div className="field">
        <label>Description</label>
        <Field
          type="text"
          component="input"
          name={`pbt_custom_images_attributes[${index}].description`}
        />
      </div>

      {showDestroy && (
        <div className="field">
          <label>Delete</label>
          <Field
            type="checkbox"
            component="input"
            name={`pbt_custom_images_attributes[${index}]._destroy`}
          />
        </div>
      )}
    </div>
  )
}

export default PbtCustomImage
